/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_ZhInputs */

const en_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const es_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const de_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const zh_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const ar_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const fr_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const vi_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const sw_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const th_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const bs_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const ja_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const ko_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const pt_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const it_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const sv_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const nl_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const da_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const nb_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const fi_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const pl_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const ru_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const tr_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const hi_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const id_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const ms_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const cs_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const el_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const he_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const af_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

const hu_nav_language_zh = /** @type {(inputs: Nav_Language_ZhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中文`)
};

/**
* | output |
* | --- |
* | "中文" |
*
* @param {Nav_Language_ZhInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_zh = /** @type {((inputs?: Nav_Language_ZhInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_ZhInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_zh(inputs)
	if (locale === "de") return de_nav_language_zh(inputs)
	if (locale === "zh") return zh_nav_language_zh(inputs)
	if (locale === "ar") return ar_nav_language_zh(inputs)
	if (locale === "fr") return fr_nav_language_zh(inputs)
	if (locale === "vi") return vi_nav_language_zh(inputs)
	if (locale === "sw") return sw_nav_language_zh(inputs)
	if (locale === "th") return th_nav_language_zh(inputs)
	if (locale === "bs") return bs_nav_language_zh(inputs)
	if (locale === "ja") return ja_nav_language_zh(inputs)
	if (locale === "ko") return ko_nav_language_zh(inputs)
	if (locale === "pt") return pt_nav_language_zh(inputs)
	if (locale === "it") return it_nav_language_zh(inputs)
	if (locale === "sv") return sv_nav_language_zh(inputs)
	if (locale === "nl") return nl_nav_language_zh(inputs)
	if (locale === "da") return da_nav_language_zh(inputs)
	if (locale === "nb") return nb_nav_language_zh(inputs)
	if (locale === "fi") return fi_nav_language_zh(inputs)
	if (locale === "pl") return pl_nav_language_zh(inputs)
	if (locale === "ru") return ru_nav_language_zh(inputs)
	if (locale === "tr") return tr_nav_language_zh(inputs)
	if (locale === "hi") return hi_nav_language_zh(inputs)
	if (locale === "id") return id_nav_language_zh(inputs)
	if (locale === "ms") return ms_nav_language_zh(inputs)
	if (locale === "cs") return cs_nav_language_zh(inputs)
	if (locale === "el") return el_nav_language_zh(inputs)
	if (locale === "he") return he_nav_language_zh(inputs)
	if (locale === "af") return af_nav_language_zh(inputs)
	if (locale === "hu") return hu_nav_language_zh(inputs)
	return en_nav_language_zh(inputs)
});